export const FEATURE_NAMES = {
  PAYMENT_WALLET: 'PAYMENT_WALLET',
  PAYMENT_DPG: 'PAYMENT_DPG',
  PAYMENT_IPG: 'PAYMENT_IPG',
  SETTINGS: 'SETTINGS',
  SETTINGS_PASSWORD: 'SETTINGS_PASSWORD',
  SETTINGS_CASH_OUT: 'SETTINGS_CASH_OUT',
  LOGIN_HOME: 'LOGIN_HOME',
  SDK_INFO: 'SDK_INFO',
  NAV_HOME: 'NAV_HOME',
  NAV_TRANSACTIONS: 'NAV_TRANSACTIONS',
  NAV_BARCODE_READER: 'NAV_BARCODE_READER',
  NAV_FESTIVAL: 'NAV_FESTIVAL',
  NAV_STORES: 'NAV_STORES',
  SETTINGS_REFERRAL: 'SETTINGS_REFERRAL',
  SETTINGS_SESSIONS: 'SETTINGS_SESSIONS',
  SETTINGS_C2C_MANAGEMENT: 'SETTINGS_C2C_MANAGEMENT',
  SETTINGS_TERMS: 'SETTINGS_TERMS',
  SETTINGS_ABOUT_US: 'SETTINGS_ABOUT_US',
  SETTINGS_FEEDBACK: 'SETTINGS_FEEDBACK',
  SETTINGS_HELP: 'SETTINGS_HELP',
  SETTINGS_PROFILE: 'SETTINGS_PROFILE',
  SETTINGS_UPDATE: 'SETTINGS_UPDATE',
};

export const FEATURES = {
  [FEATURE_NAMES.PAYMENT_WALLET]: 0,
  [FEATURE_NAMES.PAYMENT_DPG]: 1,
  [FEATURE_NAMES.PAYMENT_IPG]: 2,
  [FEATURE_NAMES.SETTINGS]: 50,
  [FEATURE_NAMES.SETTINGS_PASSWORD]: 51,
  [FEATURE_NAMES.SETTINGS_CASH_OUT]: 61,
  [FEATURE_NAMES.LOGIN_HOME]: 100,
  [FEATURE_NAMES.SDK_INFO]: 150,
  [FEATURE_NAMES.NAV_HOME]: 200,
  [FEATURE_NAMES.NAV_TRANSACTIONS]: 201,
  [FEATURE_NAMES.NAV_BARCODE_READER]: 202,
  [FEATURE_NAMES.NAV_FESTIVAL]: 203,
  [FEATURE_NAMES.NAV_STORES]: 204,
  [FEATURE_NAMES.SETTINGS_REFERRAL]: 52,
  [FEATURE_NAMES.SETTINGS_SESSIONS]: 65,
  [FEATURE_NAMES.SETTINGS_C2C_MANAGEMENT]: 53,
  [FEATURE_NAMES.SETTINGS_TERMS]: 54,
  [FEATURE_NAMES.SETTINGS_ABOUT_US]: 55,
  [FEATURE_NAMES.SETTINGS_FEEDBACK]: 56,
  [FEATURE_NAMES.SETTINGS_HELP]: 57,
  [FEATURE_NAMES.SETTINGS_PROFILE]: 58,
  [FEATURE_NAMES.SETTINGS_UPDATE]: 59,
};
